import { Button, Result, Typography } from 'antd';
import { Link } from 'react-router-dom';
import { useAuth } from '../../auth/store';

/**
 * 403 for a page the signed-in admin has no permission for.
 *
 * Shown instead of the page whenever the route is reached — including by
 * typing the URL, following a stale bookmark, or hitting Back. Hiding the menu
 * item is a convenience; THIS is what makes the route unreachable in the
 * panel, and the API refuses the underlying calls regardless.
 */
export function ForbiddenPage({ permission }: { permission?: string }) {
  const profile = useAuth((s) => s.profile);
  return (
    <Result
      status="403"
      title="403 — Access denied"
      subTitle={
        <span>
          Your account{profile ? ` (${profile.role})` : ''} does not have permission to open this
          page.
          {permission && (
            <>
              {' '}
              It needs <Typography.Text code>{permission}</Typography.Text>.
            </>
          )}
          <br />
          Ask a super admin to grant it under <strong>Sub admins → Permissions</strong>.
        </span>
      }
      extra={
        <Link to="/">
          <Button type="primary">Back to dashboard</Button>
        </Link>
      }
    />
  );
}
